import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { BaseService } from 'src/app/core/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class FederationService extends BaseService{

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  /**
   * getFederation() - Buscar lista de federações
   */
  getFederation(): Observable<any> {
    
    // Instancia do body através de BaseService.setBody();
    let body = this.setBody();

    let response = this.http
      .post(this.urlService + this.routeAdress.route_affiliateds, body.toString())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError));

    return response;
  }

}
